import { Breadcrumbs } from '@shared/ui/breadcrumbs';
import { useLoaderData, useRouteLoaderData } from '@shared/lib/routing';
import { PageContainer } from '@shared/ui/content-containers';
import { PageTitle } from '@shared/ui/titles';
import ErrorPage from 'src/frontend/Pages/ErrorPage/ErrorPage';
import { Preloader } from '@shared/ui/preloader';
import { PageBanner, ISeoPage, PageHelmet } from '@widgets/seoPage';
import { HtmlParser } from '@shared/html';
import type { IPage } from '../model';

export function StaticPage() {
  const { pageData, loading } = useLoaderData<{
    staticPageData: { page: IPage[] };
    seoPageData: ISeoPage;
  }>();
  const { country, city } = useRouteLoaderData('city-layout');
  if (loading) {
    return <Preloader />;
  }
  const {
    seoPageData,
    staticPageData: { page },
  } = pageData;

  if (page && page.length === 0) {
    return <ErrorPage />;
  }

  const { title, description } = page[0];

  return (
    <>
      <PageBanner
        bannerData={seoPageData.banner}
        mainDomain={country.main_domain}
      />
      <PageHelmet
        cityName={city.city_name}
        seo={seoPageData.seo}
        title={title}
        mainDomain={country.main_domain}
      />
      <PageContainer>
        <Breadcrumbs
          links={[
            {
              text: title,
            },
          ]}
        />
        <PageTitle>{title}</PageTitle>
        <HtmlParser
          data={description}
          imgProps={{ mainDomain: country.main_domain }}
        />
      </PageContainer>
    </>
  );
}
